export default "__VITE_ASSET__DbZxXAtc__"